import helpers from '@/router/helpers';
import UserRoles from '@/constants/user/roles';

export default {
    path: '/mail/receive',
    meta: {
        title: 'Receive',
        documentTitle: 'Mail Receive',
        requiresAuth: true,
        mdiIcon: 'inbox-arrow-down',
        allowedRoles: [
            UserRoles.SUPER_ADMIN,
            UserRoles.MAIL_OPERATOR,
        ],
    },
    component: helpers.getRouterView(),
    children: [
        {
            path: '',
            name: 'MailReceive',
            meta: {
                title: 'Receive',
                documentTitle: 'Mail Receive',
                shouldPersistBetweenLogins: true,
                allowedRoles: [
                    UserRoles.SUPER_ADMIN,
                    UserRoles.MAIL_OPERATOR,
                ],
            },
            component: () => import( /* webpackChunkName: "MailReceive" */ '@/views/mail/Receive' ),
        },
    ],
};
